// src/APIs/geoApi.js
import axios from "axios";

const GEO_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/v1/geo`;

export const getStates = async () => {
  const { data } = await axios.get(`${GEO_BASE}/states`);
  // Expect: [{ id, name, countryId, stateCode }]
  return data || [];
};

export const getCitiesByState = async (stateId) => {
  if (!stateId) return [];
  const { data } = await axios.get(`${GEO_BASE}/states/${stateId}/cities`);
  // Expect: [{ id, name, stateId }]
  return data || [];
};

export const geocodeZip = async (zip) => {
  const { data } = await axios.get(
    `${GEO_BASE}/geocode?address=${encodeURIComponent(zip)}&country=US`,
  );
  return data; // { latitude, longitude, city, state, postalCode, ... }
};
